/** UTF-8 safe base64 encode, matching the backend's expected `base64(email)` / `base64(password)`. */
export function toBase64(value: string): string {
  return btoa(unescape(encodeURIComponent(value)));
}
